<template>
    <div
        class="bg-white w-full h-2/5 lg:w-1/2 lg:h-full rounded-b-xl lg:rounded-r-xl  border-t lg:border-l border-gray-100 relative">
        <div
            class="h-2/12 flex justify-between items-center  border-b border-gray-100 bg-gray-50 rounded-b-xl lg:rounded-none lg:rounded-tr-xl pl-5">
            <div class=" text-gray-700 h-full flex justify-center items-center text-xl font-medium">
                {{ $t("cart_information") }}
            </div>
            <div class="h-full  flex justify-end items-center ">
                <div class="w-1/3 h-full flex flex-col justify-center items-center">
                    <img class="w-3/5 lg:w-11/12 lg:mr-5 rounded-xl" :src="'https://api.gifty.opus.win' + (props.store ? (props.store.image ? props.store.image : props.service.image) : '')"
                        alt="">
                </div>
            </div>
        </div>

        <div class="h-10/12 lg:h-9/12 w-full rounded-b-xl  lg:rounded-br-xl   overflow-y-auto bg-white px-5 ">

            <ProductCard :products="cart.products"></ProductCard>

        </div>

        <div
            class="h-1/12 bg-gray-100 w-full   rounded-b-xl lg:rounded-br-xl  absolute bottom-0 hidden lg:flex justify-end border-t border-gray-200">

            <div class="text-lg p-3">
                <span class="font-bold ">{{ cart.total }} {{ $t("currencyName") }}</span>
            </div>

        </div>
    </div>



</template>


<script setup>

import { defineProps } from 'vue';
import ProductCard from './productCard.vue';

const props = defineProps({
    cart: Object,
    store: Object,
    service: Object

});


</script>